import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

import { AlertService } from 'src/app/shared/components/app-alert';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-customer-page-selfupdate',
  templateUrl: './customer-page-selfupdate.component.html',
  styleUrls: ['./customer-page-selfupdate.component.sass']
})
export class CustomerPageSelfupdateComponent implements OnInit {

  @Input() customerId: string;

  public file: File;
  public latestRequest: any = {};

  constructor(
    private alert: AlertService,
    private api: ApiService
  ) { }

  ngOnInit(): void {
    this.api.get(
      `customers/${this.customerId}/latestrequest`,
      result => this.latestRequest = result
    );
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
    }
  }

  onFileSend() {
    if (this.latestRequest.ResponseStatus === 'Return_Update' || this.latestRequest.ResponseStatus === 'Return_Self_Update') {
      this.alert.warn(`The file cannot be sent to a customer with response status ${this.latestRequest.ResponseStatus} of the latest request. Please, try later.`);
      return;
    }
    if (this.file) {
      this.api.upload(
        `customers/${this.customerId}/SetSelfUpdate`,
        this.file,
        event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round(100 * event.loaded / event.total);
              return { status: 'progress', message: progress };
            case HttpEventType.Response:
              if (event.status == 200)
                this.alert.success(`The file was sent successfully`);
              return event.statusText;
            default:
              return `Unhandled event: ${event.type}`;
          }
        }
      );
    } else {
      this.alert.error('No selected file to send');
    }
  }
}
